import moment from 'moment';
import constants from './constants';

const initState = {
  consultAttribute: {
    attribute: 'StGe',
    dateConsult: [
      moment(moment().format('YYYY-MM-DD 00:00:00')).utcOffset('+00:00').format('YYYY-MM-DD HH:mm:ss'),
      moment(moment().format('YYYY-MM-DD 23:59:59')).utcOffset('+00:00').format('YYYY-MM-DD HH:mm:ss'),
    ],
    granularity: 'minute',
  },
  consultAttributeBattery: {
    dateConsult: [
      moment(moment().format('YYYY-MM-DD 00:00:00')).utcOffset('+00:00').format('YYYY-MM-DD HH:mm:ss'),
      moment(moment().format('YYYY-MM-DD 23:59:59')).utcOffset('+00:00').format('YYYY-MM-DD HH:mm:ss'),
    ],
  },
  loadingAttributeGraph: false,
  loadingBatteryGraph: false,
  loadingBatteryGraphBoxPLot: false,
  typeConsultBattery: constants.BATTERY_CONSULT,
  typeConsultBatteryBoxPlot: constants.BOX_CONSULT,
  generalInfo: {
    address: '',
    client: '',
    inverterCapacity: '',
    locationDevice: '',
    solarCapacity: '',
    storageCapacity: '',
    device: '',
    inverterModel: '',
  },
  generalDeviceInfo: {
    client: '',
    name: '',
    mac: '',
    business: '',
    portal: '',
    firmware: '',
    device_types: '',
  },
  infoSystem: {
    systemStatus: '',
    mode: '',
    solarPower: 0,
    socBattery: 0,
    statusBattery: '',
    loadConsumption: 0,
    powerGrid: 0,
    gridStatus: '',
  },
  loadingInfoSystem: false,
  generalStatistics: {
    importEnergy: 0,
    dischargeEnergy: 0,
    storageEnergy: 0,
    CO2: 0,
    exportEnergy: 0,
    consumptionEnergy: 0,
    energySelfConsumption: 0,
    energyGenerated: 0,
  },
  totalStatistics: {
    total_discharged_energy: 0,
    total_stored_energy: 0,
    total_self_consumed_energy: 0,
    total_imported_energy: 0,
    total_exported_energy: 0,
    total_generated_energy: 0,
  },
  graphInitialData: {
    dates: [],
    graphData: [],
    typeGraph: 'area',
    labels: [],
    units: '',
  },
  graphBatteryData: {
    dates: [],
    graphData: [],
    typeGraph: 'area',
    labels: [],
    units: '',
  },
  graphBatteryBoxPlot: {
    dates: [],
    graphData: [],
    typeGraph: 'boxPlot',
    labels: [],
    units: '',
  },
  deviceId: '',
  generalBusinessTypeInfo: {},
  allDevices: [],
  allInverters: [],
  edgeNames: [],
  consultAttributeBatteryBoxPlot: {
    dateConsult: [
      moment().day('Sunday').year(2021).week(moment(new Date()).week())
        .format('YYYY-MM-DD 00:00:00'),
      moment().day('Saturday').year(2021).week(moment(new Date()).week())
        .format('YYYY-MM-DD 23:59:59'),
    ],
  },
};

function graphReducer(state = initState, { type, payload }) {

  switch (type) {

    case constants.DELETE_INVERTER_DATA:
      return {
        ...state,
        allInverters: payload,
      };

    case constants.CONSULT_ATTRIBUTE:
      return {
        ...state,
        consultAttribute: payload,
      };

    case constants.CONSULT_ATTRIBUTE_BATTERY:
      return {
        ...state,
        consultAttributeBattery: payload,
      };

    case constants.LOADING_ATTRIBUTE_GRAPH:
      return {
        ...state,
        loadingAttributeGraph: payload,
      };

    case constants.LOADING_BATTERY_GRAPH:
      return {
        ...state,
        loadingBatteryGraph: payload,
      };

    case constants.LOADING_BATTERY_GRAPH_BOX_PLOT:
      return {
        ...state,
        loadingBatteryGraphBoxPLot: payload,
      };

    case constants.LOADING_INFO_SYSTEM:
      return {
        ...state,
        loadingInfoSystem: payload,
      };

    case constants.TYPE_CONSULT_BATTERY:
      return {
        ...state,
        typeConsultBattery: payload,
      };

    case constants.TYPE_CONSULT_BATTERY_BOX_PLOT:
      return {
        ...state,
        typeConsultBatteryBoxPlot: payload,
      };

    case constants.GENERAL_INFO:
      return {
        ...state,
        generalInfo: payload,
      };

    case constants.INFO_SYSTEM:
      return {
        ...state,
        infoSystem: payload,
      };

    case constants.GENERAL_STATISTICS:
      return {
        ...state,
        generalStatistics: payload,
      };

    case constants.TOTAL_STATISTICS:
      return {
        ...state,
        totalStatistics: payload,
      };

    case constants.GRAPH_INITIAL_DATA:
      return {
        ...state,
        graphInitialData: payload,
      };

    case constants.GRAPH_BATTERY_DATA:
      return {
        ...state,
        graphBatteryData: payload,
      };

    case constants.GRAPH_BATTERY_DATA_BOX_PLOT:
      return {
        ...state,
        graphBatteryBoxPlot: payload,
      };

    case constants.DEVICE_ID:
      return {
        ...state,
        deviceId: payload,
      };

    case constants.DATA_DEVICES_TABLE:
      return {
        ...state,
        allDevices: payload,
      };

    case constants.ALL_INVERTERS_DATA:
      return {
        ...state,
        allInverters: payload,
      };

    case constants.EDGE_NAMES:
      return {
        ...state,
        edgeNames: payload,
      };

    case constants.CONSULT_ATTRIBUTE_BATTERY_BOX_PLOT:
      return {
        ...state,
        consultAttributeBatteryBoxPlot: payload,
      };

      // Miguel

    case constants.INFO_BUSINESS_TYPE:
      return {
        ...state,
        generalBusinessTypeInfo: payload,
      };

    case constants.ALL_DEVICES_DATA:
      return {
        ...state,
        allDevices: payload,
      };

    case constants.GENERAL_DEVICE_INFO:
      return {
        ...state,
        generalDeviceInfo: payload,
      };

    default:
      return state;

  }

}

export default graphReducer;
